/**
 * Capitalizes the first letter of each word in a given string.
 *
 * @param {string} str - The input string to be capitalized.
 * @returns {string} The capitalized string.
 */
export function capitalizeWords(str) {
	// Split the string into an array of words
	const words = str.split(' ');

	// Capitalize the first letter of each word
	const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));

	// Join the capitalized words back into a string
	const capitalizedString = capitalizedWords.join(' ');

	return capitalizedString;
}

export default capitalizeWords;
